import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import {
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    TextField,
    Typography,
    Select,
    MenuItem,
    Grid,
    Checkbox,
    FormControlLabel,
    useMediaQuery,
    useTheme,
    Button,
    Switch,
    Card
} from "@mui/material";
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { getCustomers, getAuthProviders, getAuthProviderByCustomerId, getSSOProviderHistory,
         updateAuthProviderByCustomerId, disableSSOProviderByCustomerId } from "apis/CustomersApis";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import SsoMobile from "./SsoMobile";
import { set } from "lodash";

const { primary, secondary, text, tableRow, transparent } = colors;
const { size } = typography;

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`sso-tabpanel-${index}`}
            aria-labelledby={`sso-tab-${index}`}
            {...other}
        >
            <Box m={0} p={0}>{children}</Box>
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `sso-tab-${index}`,
        'aria-controls': `sso-tabpanel-${index}`,
    };
}

const SsoForm = () => {

    const [ssoAuthProvider, setSsoAuthProvider] = useState("");
    const [disableSso, setDisableSso] = useState(false);
    const Token = useSelector(state => state.accessToken);
    const [ssoClientId, setSsoClientId] = useState("");
    const [ssoTenantId, setSsoTenantId] = useState("");
    const [ssoClientSecret, setSsoClientSecret] = useState("");
    // const [oktaClientSecret, setOktaClientSecret] = useState("");
    const [ssoIssuer, setSsoIssuer] = useState("");

    const [isAzureAdProvider, setIsAzureAdProvider] = useState(false);
    const [isOktaProvider, setIsOktaProvider] = useState(false);
    const [isValid, setIsValid] = useState(false);

    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
    const OKTA_AUTH_PROVIDER = "Okta";
    const AZURE_AUTH_PROVIDER = "AzureAD";
    const MAVRIC_AUTH_PROVIDER = "Mavric";

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const [authProviderList, setAuthProviderList] = useState([{ auth_provider: "Mavric" }]);
    const [authProviderData, setAuthProviderData] = useState({});
    const [custDataList, setCustDataList] = useState([]);
    const [isCustomerDataEmpty, setIsCustomerDataEmpty] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState({ customer_id: 0, org_name: "", sso_auth_provider: "", sso_enabled: false });
    // const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [isDisabledInput, setIsDisabledInput] = useState((selectedCustomer.sso_auth_provider === "Mavric" && selectedCustomer.sso_enabled === false) ? true : false);
    // const [isDisabledInput, setIsDisabledInput] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const APP_TYPE = "web";
    const prevCustomerId = useRef(null);
    const prevTabValue = useRef(null);
    // const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [previousSettings, setPreviousSettings] = useState(null);
    const prevSsoAuthProviderRef = useRef(ssoAuthProvider);


    const checkValidity = () => {
        let isValidInput = true;
        switch (ssoAuthProvider) {
            case OKTA_AUTH_PROVIDER:
                if (ssoClientId.trim() !== '' && ssoIssuer !== '') {
                    isValidInput = true;
                    setIsValid(true);
                } else {
                    isValidInput = false;
                    setIsValid(false);
                }
                break;
            case AZURE_AUTH_PROVIDER:
                if (ssoClientId.trim() !== '' && ssoTenantId !== '' && ssoClientSecret !== '') {
                    isValidInput = true;
                    setIsValid(true);
                } else {
                    isValidInput = false;
                    setIsValid(false);
                }
                break;
            default:
                isValidInput = true;
                setIsValid(true);

        }
        return isValidInput


    };

    useEffect(() => {
        if (!authProviderData || !selectedCustomer) return;
        if (authProviderData && selectedCustomer) {
            const provider = authProviderData.sso_enabled ? authProviderData.auth_provider : MAVRIC_AUTH_PROVIDER;
            setSsoAuthProvider(provider);

            // Update form fields 
            setSsoClientId(authProviderData.client_id || "");
            setSsoIssuer(authProviderData.issuer || "");
            setSsoTenantId(authProviderData.tenant_id || "");
            setSsoClientSecret(authProviderData.client_secret || "");
            // setOktaClientSecret(authProviderData.client_secret || "");

            setSelectedCustomer(prev => ({
                ...prev,
                sso_auth_provider: provider,
                sso_enabled: authProviderData.sso_enabled,
                client_id: authProviderData.client_id,
                issuer: authProviderData.issuer,
                tenant_id: authProviderData.tenant_id,
                client_secret: authProviderData.client_secret
            }));

            // setDisableSso(provider === MAVRIC_AUTH_PROVIDER ? false : !authProviderData.sso_enabled);
            setDisableSso(!authProviderData.sso_enabled);
            // setDisableSso(provider === MAVRIC_AUTH_PROVIDER ? true : !authProviderData.sso_enabled);
            setIsDisabledInput(provider === MAVRIC_AUTH_PROVIDER);
        }
    }, [authProviderData,]);

    useEffect(() => {
        switch (ssoAuthProvider) {
            case OKTA_AUTH_PROVIDER:
                setIsAzureAdProvider(false);
                setIsOktaProvider(true);
                if (authProviderData.auth_provider == MAVRIC_AUTH_PROVIDER && (!checkValidity())) {
                    setIsValid(false);
                } else (checkValidity());
                break;
            case AZURE_AUTH_PROVIDER:
                setIsAzureAdProvider(true);
                setIsOktaProvider(false);
                if (authProviderData.auth_provider == MAVRIC_AUTH_PROVIDER && (!checkValidity())) {
                    setIsValid(false);
                } else (checkValidity());
                break;
            default:
                setIsAzureAdProvider(false);
                setIsOktaProvider(false);
                setIsValid(true);

        }
    }, [ssoAuthProvider]);


    useEffect(() => {
        checkValidity();
    }, [ssoClientId, ssoTenantId, ssoClientSecret, ssoIssuer, ssoAuthProvider]);


    const handleCloseConfirmation = () => {
        setOpenConfirmationDialog(false);
        // setSaveData(null);
    };

    const handleOpenConfirmation = (data) => {
        // setSaveData(data);
        setOpenConfirmationDialog(true);
    };

    // const handleSsoDialogClose = () => setOpenSso(false);

    const onChangeDisabledSso = (e) => {
        let isChecked = e.target.checked;
        setDisableSso(!isChecked);

        const isMavricAuth = selectedCustomer.sso_auth_provider === MAVRIC_AUTH_PROVIDER;
        setIsDisabledInput(!isChecked);

        if (!isChecked) {
            setIsValid(checkValidity());
        } else {
            setIsValid(isChecked);
        }
    }

    const getCustomerData = () => {
        // console.log("Token::", Token);
        return new Promise(function (resolve, reject) {
            getCustomers().then((response) => {
                //setProcessing(false);
                setCustDataList(response);
                // setSelectedCustomer(response[0]);
                // getAuthProviderDataByCustomerId(response[0].customer_id);
                resolve(response);
                // console.log("get all customer: ", response);

            }).catch((error) => {
                //setProcessing(false);
                setCustDataList([]);
                let errMessage = '';

                if (error.response) {
                    errMessage = error.response.data.message;
                    if (error.response.status === 401 || error.response.status === 403) {
                        // <Redirect from="/" to="/login" />
                        let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                        dispatch(logout(jsonPostMsg));
                        history.push('/login');
                    }
                } else if (error.request) {
                    errMessage = `${error}`;
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    errMessage = error.message;
                }
                reject(errMessage);
            });
        });
    };

    const getAuthProviderData = () => {
        // console.log("Token::", Token);
        return new Promise(function (resolve, reject) {
            getAuthProviders().then((response) => {
                setAuthProviderList(response);
                resolve(response);
            }).catch((error) => {
                setAuthProviderList([]);
                let errMessage = '';

                if (error.response) {
                    errMessage = error.response.data.message;
                    if (error.response.status === 401 || error.response.status === 403) {
                        let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                        dispatch(logout(jsonPostMsg));
                        history.push('/login');
                    }
                } else if (error.request) {
                    errMessage = `${error}`;
                    // The request was made but no response was received
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                    errMessage = error.message;
                }
                reject(errMessage);
            });
        });
    };

    // Fetch SSO AuthProvider details by Customer ID
    const fetchPreviousSettings = async (provider) => {
        try {
            const response = await getSSOProviderHistory(selectedCustomer.customer_id,APP_TYPE, provider);
            setPreviousSettings(response);
            // console.log("History data:", response);
            // console.log("Current data:", authProviderData);
            // console.log("isHistoryValid:", isHistoryValid(authProviderData, previousSettings));
            // console.log("Selected Customer:", selectedCustomer);

            // Check if current data is valid
            const hasCurrentValidData = authProviderData &&
                authProviderData.auth_provider !== MAVRIC_AUTH_PROVIDER &&
                ((provider === AZURE_AUTH_PROVIDER && authProviderData.client_id && authProviderData.tenant_id && authProviderData.client_secret) ||
                    (provider === OKTA_AUTH_PROVIDER && authProviderData.client_id && authProviderData.issuer));

            if (hasCurrentValidData) {
                // console.log("Showing current settings (existing user)");
                if (provider === AZURE_AUTH_PROVIDER) {
                    setSsoClientId(authProviderData.client_id || "");
                    setSsoTenantId(authProviderData.tenant_id || "");
                    setSsoClientSecret(authProviderData.client_secret || "");
                } else if (provider === OKTA_AUTH_PROVIDER) {
                    setSsoClientId(authProviderData.client_id || "");
                    setSsoIssuer(authProviderData.issuer || "");
                }
            } else if (response) {
                // console.log("Showing history settings (new user with history)");
                if (provider === AZURE_AUTH_PROVIDER) {
                    setSsoClientId(response.client_id || '');
                    setSsoTenantId(response.tenant_id || '');
                    setSsoClientSecret(response.client_secret || '');
                } else if (provider === OKTA_AUTH_PROVIDER) {
                    setSsoClientId(response.client_id || '');
                    setSsoIssuer(response.issuer || '');
                }
            } else {
                // console.log("No settings available - clearing fields");
                setSsoClientId('');
                setSsoTenantId('');
                setSsoClientSecret('');
                setSsoIssuer('');
            }

        } catch (error) {
            console.error('Error fetching SSO history:', error);
            setPreviousSettings(null);
        }
    };

    useEffect(() => {
        if (prevSsoAuthProviderRef.current !== ssoAuthProvider) {
            setSsoClientId("");
            setSsoClientSecret("");
        }
        if (ssoAuthProvider === AZURE_AUTH_PROVIDER || ssoAuthProvider === OKTA_AUTH_PROVIDER) {
            fetchPreviousSettings(ssoAuthProvider);
        }

        prevSsoAuthProviderRef.current = ssoAuthProvider;
    }, [ssoAuthProvider]);

    const getAuthProviderDataByCustomerId = (customerId, app) => {
        // console.log("Fetching SSO AuthProvider for Customer ID:", customerId);
        return new Promise(function (resolve, reject) {
            getAuthProviderByCustomerId(customerId, app)  // API call to get SSO AuthProvider details
                .then((response) => {
                    setAuthProviderData(response);
                    // console.log(response);
                    resolve(response);
                })
                .catch((error) => {
                    setAuthProviderData([]);
                    let errMessage = '';
                    if (error.response) {
                        errMessage = error.response.data.message;
                        if (error.response.status === 401 || error.response.status === 403) {
                            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
                            dispatch(logout(jsonPostMsg));
                            history.push('/login');
                        }
                    } else if (error.request) {
                        errMessage = `${error}`;
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                        errMessage = error.message;
                    }
                    reject(errMessage);
                });
        });
    };

    useEffect(() => {
        getCustomerData();
        getAuthProviderData();
    }, []);

    // const shouldUpdateProvider = () => {
    //     // if (selectedCustomer && selectedCustomer.customer_id) {
    //         // Check for web provider updates
    //         if (ssoAuthProvider === OKTA_AUTH_PROVIDER) {
    //             return (
    //                 selectedCustomer.sso_auth_provider !== ssoAuthProvider ||
    //                 selectedCustomer.client_id !== ssoClientId ||
    //                 selectedCustomer.issuer !== ssoIssuer 
    //             );
    //         }

    //         if (ssoAuthProvider === AZURE_AUTH_PROVIDER) {
    //             return (
    //                 selectedCustomer.sso_auth_provider !== ssoAuthProvider ||
    //                 selectedCustomer.client_id !== ssoClientId ||
    //                 selectedCustomer.tenant_id !== ssoTenantId ||
    //                 selectedCustomer.client_secret !== ssoClientSecret
    //             );
    //         }
    //     // }
    //     return false;
    // };

    const handleSave = async (event) => {
        event.preventDefault();
        try {
            if (selectedCustomer.customer_id === null) return;

            // console.log("Current state:", {
            //     selectedProvider: selectedCustomer.sso_auth_provider,
            //     formProvider: ssoAuthProvider,
            //     disableSso
            // });

            if (selectedCustomer.sso_auth_provider !== MAVRIC_AUTH_PROVIDER && disableSso) {
                await disableSSOProviderByCustomerId(selectedCustomer.customer_id, APP_TYPE);

                setSsoAuthProvider(MAVRIC_AUTH_PROVIDER);
                setSsoClientId("");
                setSsoTenantId("");
                setSsoClientSecret("");
                // setOktaClientSecret("");
                setSsoIssuer("");
                setDisableSso(false);
                setIsDisabledInput(true);
            }

            // await new Promise(resolve => setTimeout(resolve, 100)); 
            else if (ssoAuthProvider === OKTA_AUTH_PROVIDER || ssoAuthProvider === AZURE_AUTH_PROVIDER) {
                let identityProvider = null;
                if (ssoAuthProvider === OKTA_AUTH_PROVIDER) identityProvider = {
                    "auth_provider": OKTA_AUTH_PROVIDER,
                    "client_id": ssoClientId,
                    "issuer": ssoIssuer,
                    // "client_secret": oktaClientSecret
                };
                else if (ssoAuthProvider === AZURE_AUTH_PROVIDER) identityProvider = {
                    "auth_provider": AZURE_AUTH_PROVIDER,
                    "client_id": ssoClientId,
                    "tenant_id": ssoTenantId,
                    "client_secret": ssoClientSecret
                };
                // console.log("[SAVE from web] Okta payload = ", identityProvider);
                if (identityProvider) {
                    // console.log("Updating auth provider:", identityProvider);
                    await updateAuthProviderByCustomerId(selectedCustomer.customer_id, ssoAuthProvider, identityProvider, APP_TYPE);

                }
            }
            // await getCustomerData();
            await getAuthProviderData();
            await getAuthProviderDataByCustomerId(selectedCustomer.customer_id, APP_TYPE);

        } catch (error) {
            console.error("Error while updating auth provider:", error);
            alert("An error occurred. Please try again.");
        }
        // handleCloseDialog();
        handleCloseConfirmation();

    };


    const handleCustomerChange = async (e) => {
        const selectedOrgName = e.target.value;
        const selectedCustomer = custDataList.find(customer => customer.org_name === selectedOrgName);
        if (selectedCustomer) {
            setSelectedCustomer(selectedCustomer);
            console.log("Selected Customer:", selectedCustomer);
            
            // const appType = activeTab === 0 ? 'web' : 'mobile';
            // await getAuthProviderDataByCustomerId(selectedCustomer.customer_id, appType);
        } else {
            console.log("Invalid customerId : ", selectedCustomer.customer_id);
        }
    };

    const handleTabChange = async (event, newValue) => {
        setActiveTab(newValue);
    };

    useEffect(() => {
        if (activeTab !== 0 || !selectedCustomer || !selectedCustomer.customer_id) return;
        if (activeTab === prevTabValue.current && selectedCustomer.customer_id === prevCustomerId.current) {
            return;
        }

        getAuthProviderDataByCustomerId(selectedCustomer.customer_id, APP_TYPE).finally(
            () => {
                prevTabValue.current = activeTab;
                prevCustomerId.current = selectedCustomer.customer_id;
                // setIsInitialLoad(false);
            }
        )
    }, [activeTab, selectedCustomer]);

    useEffect(() => {
        if (custDataList.length > 0) {
            const defaultCustomer = custDataList.find(customer => customer.customer_id === custDataList[0].customer_id) || custDataList[0];
            setSelectedCustomer(defaultCustomer);
            getAuthProviderDataByCustomerId(defaultCustomer.customer_id, APP_TYPE);
            setIsCustomerDataEmpty(false);
        } else {
            setIsCustomerDataEmpty(true);
            setSelectedCustomer({ customer_id: 0, org_name: "", sso_auth_provider: "", sso_enabled: false });
            // setSelectedCustomer(null);
        }
    }, [custDataList]);


    return (
        <React.Fragment>

            <Box sx={{ width: "50%", marginBottom: 2, display: "flex", alignItems: "center", gap: 2 }}>

                <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 600, marginBottom: '8px', whiteSpace: "nowrap" }}>
                    Search Customer Name :
                </Typography>
                <Select
                    id="customerId"
                    name="customerId"
                    value={selectedCustomer != null ? selectedCustomer.org_name : ""}
                    onChange={handleCustomerChange}
                    displayEmpty
                    fullWidth
                    // disabled={custDataList.length === 0}
                    sx={{
                        '.MuiSelect-select': {
                            paddingTop: '8px !important',
                            paddingBottom: '8px !important',
                            minHeight: '35px !important',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '1em !important'
                        }
                    }}
                >
                    {custDataList && custDataList.length > 0 &&
                        custDataList.map((customer) => (
                            <MenuItem key={customer.customer_id} value={customer.org_name}>
                                {customer.org_name}
                            </MenuItem>
                        ))
                    }

                </Select>
            </Box>
            <Card
                sx={{
                    borderRadius: '10px',
                    overflow: 'hidden'
                }}>
                <Box sx={{ marginBottom: 0, }}>
                    <Box sx={{ borderColor: 'primary.focus', padding: 0 }}>
                        <Tabs
                            value={activeTab}
                            onChange={handleTabChange}
                            variant="scrollable"
                            scrollButtons="auto"
                            indicatorColor="secondary"
                            textColor="secondary"
                            allowScrollButtonsMobile={true}
                            aria-label="customer and probe tabs"
                        >
                            <Tab label="SSO Web" {...a11yProps(0)} />
                            <Tab label="SSO Mobile" {...a11yProps(1)} />
                        </Tabs>
                        <Divider sx={{ borderColor: primary.divider, mb: 0 }} />
                    </Box>

                    <TabPanel value={activeTab} index={0}>
                        <Box
                            sx={{
                                backgroundColor: theme.palette.primary.main,
                                padding: 2,
                                // borderRadius: 2,
                                // maxWidth: "600px",
                                width: "100%",
                                // boxShadow: 3,
                                // border: `1px solid red`
                            }}
                        >
                            <Typography
                                variant="body2"
                                color={theme.palette.secondary.main}
                                sx={{ fontWeight: 600, mb: 2 }}
                                gutterBottom
                            >
                                SSO Settings
                            </Typography>


                            <Grid container>
                                <Typography
                                    variant="body2"
                                    fontSize={size.sm}
                                    justifyContent="center"
                                    color={text.main}
                                    sx={{ fontWeight: 400, mb: 1 }}>
                                    Customer Name:&nbsp;{selectedCustomer ? (selectedCustomer.org_name !== null ? selectedCustomer.org_name : '') : ''}
                                </Typography>
                            </Grid>


                            <Grid container direction="row" alignItems="center">
                                <Grid item>
                                    <Switch
                                        checked={!disableSso}
                                        onChange={onChangeDisabledSso}
                                        sx={{ mb: 1 }}
                                        disabled={isCustomerDataEmpty}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </Grid>
                                <Grid item>
                                    <Typography
                                        variant="body2"
                                        fontSize={size.sm}
                                        justifyContent="center"
                                        color={text.main}
                                        sx={{ fontWeight: 400, mb: 1 }}>
                                        {disableSso ? 'Enable the SSO?' : 'Disable the SSO?'}
                                    </Typography>
                                </Grid>
                            </Grid>


                            <Grid container direction="column" spacing={2}>
                                {/* {disableSso && ( */}
                                <Grid item sx={{ marginBottom: 2 }}>
                                    <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400, }}>
                                        Single-Sign-On (SSO) Provider
                                    </Typography>
                                    <Select
                                        sx={{
                                            width: 300,
                                            ".MuiSelect-select": {
                                                paddingTop: "8px !important",
                                                paddingBottom: "8px !important",
                                                minHeight: "35px !important",
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: "1em !important",
                                            },
                                        }}
                                        id="authProvider"
                                        name="authProvider"
                                        // value={ssoAuthProvider}
                                        value={disableSso ? MAVRIC_AUTH_PROVIDER : ssoAuthProvider || MAVRIC_AUTH_PROVIDER}
                                        onChange={(e) => setSsoAuthProvider(e.target.value)}
                                        displayEmpty
                                        disabled={isDisabledInput}
                                    >
                                        {authProviderList.map((item, idx) => (
                                            <MenuItem key={`authProviderItem${idx}`} value={item.auth_provider}>
                                                {item.auth_provider}
                                            </MenuItem>
                                        ))}

                                        {!authProviderList.some(p => p.auth_provider === MAVRIC_AUTH_PROVIDER) && (
                                            <MenuItem value={MAVRIC_AUTH_PROVIDER} style={{ display: "none" }}>
                                                {MAVRIC_AUTH_PROVIDER}
                                            </MenuItem>
                                        )}
                                    </Select>
                                </Grid>
                                {/* )} */}

                                {disableSso ? (
                                    <></>
                                ) : (
                                    // Show SSO fields when switch is ON and provider is selected
                                    (isAzureAdProvider || isOktaProvider) && (
                                        <Grid container spacing={2} sx={{ paddingLeft: "18px" }}>
                                            <Grid item xs={4} sx={{ paddingLeft: "18px" }}>
                                                <Typography
                                                    variant="body2"
                                                    fontSize={size.sm}
                                                    color={text.main}
                                                    sx={{ fontWeight: 400 }}
                                                >
                                                    Single-Sign-On (SSO) Client Id*
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    id="ssoCustomerId"
                                                    name="ssoCustomerId"
                                                    placeholder="Enter SSO Application/Client Id"
                                                    autoComplete="off"
                                                    value={ssoClientId}
                                                    onChange={(e) => setSsoClientId(e.target.value)}
                                                    variant="outlined"
                                                    InputProps={{ sx: { paddingLeft: 0.5 } }}
                                                    disabled={isDisabledInput}
                                                />
                                            </Grid>

                                            {isOktaProvider ? (
                                                <>
                                                    <Grid item xs={4}>
                                                        <Typography
                                                            variant="body2"
                                                            fontSize={size.sm}
                                                            color={text.main}
                                                            sx={{ fontWeight: 400 }}
                                                        >
                                                            Single-Sign-On (SSO) Issuer*
                                                        </Typography>
                                                        <TextField
                                                            fullWidth
                                                            id="ssoIssuer"
                                                            name="ssoIssuer"
                                                            placeholder="Enter SSO Issuer"
                                                            autoComplete="off"
                                                            value={ssoIssuer}
                                                            onChange={(e) => setSsoIssuer(e.target.value)}
                                                            variant="outlined"
                                                            InputProps={{ sx: { paddingLeft: 0.5 } }}
                                                            disabled={isDisabledInput}
                                                        />
                                                    </Grid>
                                                    {/* <Grid item xs={4}>
                                                        <Typography
                                                            variant="body2"
                                                            fontSize={size.sm}
                                                            color={text.main}
                                                            sx={{ fontWeight: 400 }}
                                                        >
                                                            Single-Sign-On (SSO) Client Secret*
                                                        </Typography>
                                                        <TextField
                                                            fullWidth
                                                            id="oktaClientSecret"
                                                            placeholder="Enter SSO Password/Client Secret"
                                                            autoComplete="off"
                                                            value={oktaClientSecret}
                                                            onChange={(e) => setOktaClientSecret(e.target.value)}
                                                            variant="outlined"
                                                            InputProps={{ sx: { paddingLeft: 0.5 } }}
                                                            disabled={isDisabledInput}
                                                        />
                                                    </Grid> */}
                                                </>
                                            ) : (
                                                <>
                                                    <Grid item xs={4}>
                                                        <Typography
                                                            variant="body2"
                                                            fontSize={size.sm}
                                                            color={text.main}
                                                            sx={{ fontWeight: 400 }}
                                                        >
                                                            Single-Sign-On (SSO) Tenant Id*
                                                        </Typography>
                                                        <TextField
                                                            fullWidth
                                                            id="ssoTenantId"
                                                            placeholder="Enter SSO Tenant Id"
                                                            autoComplete="off"
                                                            value={ssoTenantId}
                                                            onChange={(e) => setSsoTenantId(e.target.value)}
                                                            variant="outlined"
                                                            InputProps={{ sx: { paddingLeft: 0.5 } }}
                                                            disabled={isDisabledInput}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <Typography
                                                            variant="body2"
                                                            fontSize={size.sm}
                                                            color={text.main}
                                                            sx={{ fontWeight: 400 }}
                                                        >
                                                            Single-Sign-On (SSO) Client Secret*
                                                        </Typography>
                                                        <TextField
                                                            fullWidth
                                                            id="ssoClientSecret"
                                                            placeholder="Enter SSO Password/Client Secret"
                                                            autoComplete="off"
                                                            value={ssoClientSecret}
                                                            onChange={(e) => setSsoClientSecret(e.target.value)}
                                                            variant="outlined"
                                                            InputProps={{ sx: { paddingLeft: 0.5 } }}
                                                            disabled={isDisabledInput}
                                                        />
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>
                                    )
                                )}

                            </Grid>
                            <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                                <Button variant="contained" color="secondary" onClick={handleOpenConfirmation} disabled={!isValid || isCustomerDataEmpty} sx={{ borderRadius: "4px", padding: "10px 20px" }}>
                                    Save
                                </Button>
                            </Box>
                        </Box>
                    </TabPanel>

                    <TabPanel value={activeTab} index={1}>
                        <SsoMobile
                            selectedCustomer={selectedCustomer}
                            authProviderList={authProviderList}
                            setSelectedCustomer={setSelectedCustomer}
                            tabValue={activeTab}
                            isCustomerDataEmpty={isCustomerDataEmpty}
                        />
                    </TabPanel>
                </Box>
            </Card>


            <Dialog
                open={openConfirmationDialog}
                onClose={handleCloseConfirmation}
                fullScreen={fullScreen}
                // maxWidth={maxWidth}
                // scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: primary.main,
                    }
                }}
            >
                <DialogTitle>
                    <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                        {'Confirmation'}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    Are you sure you want to save the changes?
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmation} color="secondary" variant="contained">
                        No
                    </Button>
                    <Button onClick={handleSave} color="secondary" variant="contained" >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>


        </React.Fragment>
    );
};

export default SsoForm;